module.exports = __webpack_public_path__ + "img/image25.5e99c008.png";